import React from "react";

const NoContent = ({ text = "No Data to Display" }) => {
    return <h4 className="no-content">{text}</h4>;
};

export default NoContent;
